import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { UserWithSummary } from '@core/interfaces/kpis.interface'
import { KpisScoreCardComponent } from '@shared/components/kpis-score-card/kpis-score-card.component'
import { SliderComponent } from '@shared/components/slider/slider.component'
import { ClicksDirective } from '@shared/directives/clicks.directive'
import { SlideItemDirective } from '@shared/directives/slider-item.directive'

@Component({
  selector: 'kpis-score-list',
  imports: [SliderComponent, SlideItemDirective, KpisScoreCardComponent, ClicksDirective],
  templateUrl: './kpis-score-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpisScoreListComponent {
  users = input.required<UserWithSummary[]>()
}
